import cls from 'classnames'
import React, { FC } from 'react'
import { Stack } from '@mantine/core'

import { ContentContainer, SiteTitle } from 'components/site'
import { ContentIntoView } from 'components/ui'
import ProductDetail from '../ProductsDetail'
import { Product } from 'types/domain'

type Props = {
  className?: string
  products: Product[]
}

const FeatureCompare: FC<Props> = ({ className, products }) => {
  return (
    <ContentIntoView rootMargin="0px 0px -200px 0px" className={className}>
      {(entry) => {
        const { isIntersecting } = entry || {}
        return (
          <ContentContainer className="flex justify-center">
            <Stack spacing={48} className="max-w-[1194px] w-full" align="center">
              <SiteTitle text="比较所有功能" isIntersecting={isIntersecting} />
              <ProductDetail products={products} />
            </Stack>
          </ContentContainer>
        )
      }}
    </ContentIntoView>
  )
}

export default FeatureCompare
